// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"9bb77cfc9002e9083b85","655":"ac52da2a722c60faba1d"}[chunkId] + ".js";
};